// Kad "Notifikasi Telegram": sambung/putus akaun Telegram untuk notifikasi segera.
import { html, mount } from '../../core/html.js';
import { post, del, session, refreshMe } from '../../core/api.js';
import { toast, withBusy, icon } from '../../core/ui.js';
import { t } from '../../core/i18n.js';

export function telegramCard() {
  if (!session.config?.telegram_enabled) return '';
  return html`<div class="panel stack" id="tg-card"></div>`;
}

export function bindTelegram(root) {
  const el = root.querySelector('#tg-card');
  if (!el) return;
  const draw = () => {
    const me = session.me;
    const linked = !!me?.telegram_chat_id;
    mount(el, html`<div class="spread"><h2 style="margin:0">${t('tg.title')}</h2>
        <span class="status ${linked ? 'ok' : ''}">${linked ? t('tg.linked') : t('tg.not_linked')}</span></div>
      <p class="small muted" style="margin:0">${t(linked ? 'tg.linked_text' : 'tg.intro')}</p>
      ${linked && me.telegram_username ? html`<p class="small" style="margin:0" translate="no">@${me.telegram_username}</p>` : ''}
      <div class="row">${linked
        ? html`<button class="btn btn-ghost btn-sm" type="button" id="tg-relink">${t('tg.relink')}</button><button class="btn btn-ghost btn-sm" type="button" id="tg-off">${t('tg.unlink')}</button>`
        : html`<button class="btn btn-primary" type="button" id="tg-on">${icon('chat')}${t('tg.connect')}</button>`}</div>
      <p class="tiny muted hidden" id="tg-wait">${t('tg.waiting')}</p>`);
    const start = (e) => withBusy(e.currentTarget, async () => {
      const r = await post('/api/me/telegram/link');
      window.open(r.url, '_blank', 'noopener');
      el.querySelector('#tg-wait').classList.remove('hidden');
      // Semak status beberapa kali selepas pengguna menekan Start di Telegram.
      let tries = 0;
      const timer = setInterval(async () => {
        tries++;
        await refreshMe().catch(() => {});
        if (session.me?.telegram_chat_id || tries > 40) {
          clearInterval(timer);
          if (session.me?.telegram_chat_id) toast(t('tg.done'));
          draw();
        }
      }, 3000);
    });
    el.querySelector('#tg-on')?.addEventListener('click', start);
    el.querySelector('#tg-relink')?.addEventListener('click', start);
    el.querySelector('#tg-off')?.addEventListener('click', (e) => withBusy(e.currentTarget, async () => {
      await del('/api/me/telegram');
      await refreshMe();
      toast(t('tg.unlinked_toast'));
      draw();
    }));
  };
  draw();
}
